const urls={production:'https://web.squarecdn.com/v1/square.js',sandbox:'https://sandbox.web.squarecdn.com/v1/square.js'};
let pending=null,selectedEnvironment=null;
const reloadError=()=>new Error('The card form environment changed. Reload this page before entering card details.');
export function loadSquareWebSdk(environment){
  if(!urls[environment]) return Promise.reject(new Error('Card processing environment is not configured. Contact your practice administrator.'));
  const scripts=[...document.querySelectorAll('script[src]')].filter(s=>Object.values(urls).includes(s.src));
  if((selectedEnvironment && selectedEnvironment!==environment)||scripts.some(s=>s.src!==urls[environment])) return Promise.reject(reloadError());
  if(window.Square){
    if(selectedEnvironment!==environment && !scripts.some(s=>s.src===urls[environment])) return Promise.reject(reloadError());
    selectedEnvironment=environment;
    return Promise.resolve(window.Square);
  }
  if(pending) return pending;
  selectedEnvironment=environment;
  const script=scripts[0]||document.createElement('script');
  pending=new Promise((resolve,reject)=>{
    let timer;
    const cleanup=()=>{clearTimeout(timer);script.removeEventListener('load',loaded);script.removeEventListener('error',failed);};
    const failed=()=>{cleanup();pending=null;selectedEnvironment=null;script.remove();reject(new Error('Card form failed to load. Please try again.'));};
    const loaded=()=>{if(!window.Square)return failed();cleanup();resolve(window.Square);};
    script.addEventListener('load',loaded);script.addEventListener('error',failed);
    timer=setTimeout(failed,20000);
    if(!scripts.length){script.src=urls[environment];script.async=true;document.head.appendChild(script);}
  });
  return pending;
}
